import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import Classes, { ACHBatch } from "model";

export default function CaptureOneTimeACH(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const secCode = ACHBatch.getSelectedSecCodeByBranding();
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .update([ "oneTimeACHPayment", "secCode" ], secCode)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showSecCode", "isActive" ], true)
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .submit();

    return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}